import app2 from '../../../images/mockups/output/1-portrait.png';
// import app3 from '../../../images/mockups/output/2-portrait.png';
import app4 from '../../../images/mockups/output/3-portrait.png';
import app5 from '../../../images/mockups/output/4-portrait.png';
import app6 from '../../../images/mockups/output/5-portrait.png';
import app7 from '../../../images/mockups/output/6-portrait.png';
import app8 from '../../../images/mockups/output/07-portrait.png';
import app9 from '../../../images/mockups/output/8-portrait.png';
import app10 from '../../../images/mockups/output/9-portrait.png';
import app11 from '../../../images/mockups/output/10-portrait.png';
import app12 from '../../../images/mockups/output/011-portrait.png';
// import app13 from '../../../images/mockups/output/012-portrait.png';
import app14 from '../../../images/mockups/output/13-portrait.png';
// import app15 from '../../../images/mockups/output/14-portrait.png';
import app16 from '../../../images/mockups/output/15-portrait.png';
// import app17 from '../../../images/mockups/output/16-portrait.png';
import app18 from '../../../images/mockups/output/17-portrait.png';
import app19 from '../../../images/mockups/output/18-portrait.png';
import app20 from '../../../images/mockups/output/19-portrait.png';
import app21 from '../../../images/mockups/output/20-portrait.png';
import app22 from '../../../images/mockups/output/21-portrait.png';
import app23 from '../../../images/mockups/output/22-portrait.png';
import app24 from '../../../images/mockups/output/23-portrait.png';
import app25 from '../../../images/mockups/output/24-portrait.png';
import app26 from '../../../images/mockups/output/asset-1-portrait.png';
import app27 from '../../../images/mockups/output/asset-2-portrait.png';



function SecondContent() {
  const stop = () => {
    document.getElementById('1').style['animation-play-state'] = 'paused';
    document.getElementById('2').style['animation-play-state'] = 'paused';
  }

  const slide = () => {
    document.getElementById('1').style['animation-play-state'] = 'running';
    document.getElementById('2').style['animation-play-state'] = 'running';
  }

  return (
    <div className="w-screen h-screen overflow-hidden">
        <div className="mt-40 flex flex-row w-max h-full">
          <div className="flex flex-row animate-scrolling-screens" id='1'>
            <img src={app2}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app4}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app5}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app6}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app7}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app8}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
          {/* </div>
          <div className="flex flex-row animate-scrolling-screens" id='2'> */}
            <img src={app9}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app10}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app11}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app12}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app14}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app16}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app18}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app19}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app20}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app21}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app22}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app23}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app24}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app25}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app26}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />
            <img src={app27}  className="h-2/3 hover:h-5/6 hover:-mx-20 duration-500" onMouseEnter={stop} onMouseLeave={slide} alt='app' />

          </div>
      </div>
    </div>
  );
}

export default SecondContent;